var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group mb-4" },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.name } }, [
            _vm._v(_vm._s(_vm.label) + " "),
            _vm.tooltip && _vm.tooltip !== ""
              ? _c("span", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: { content: _vm.tooltip, delay: 1500 },
                      expression: "{ content: tooltip, delay: 1500 }"
                    }
                  ],
                  staticClass: "fa fa-info-circle",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-select",
        {
          attrs: {
            options: _vm.options,
            value: _vm.value,
            multiple: _vm.multiple,
            max: _vm.max,
            taggable: _vm.taggable,
            clearable: _vm.clearable,
            placeholder: _vm.placeholder
          },
          on: { input: _vm.updateValue }
        },
        [
          _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
            _vm._v(" Geen opties beschikbaar.")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.error !== ""
        ? _c("div", {
            staticClass: "invalid-feedback",
            domProps: { innerHTML: _vm._s(_vm.error) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/fields/SelectField.vue?vue&type=template&id=ed010708&
// module id = 385
// module chunks = 0